﻿import $ from 'jquery';
import Element from "./element";

declare global {

  interface JQuery {
    readonly(shouldClearValue?: boolean): JQuery;
    editable(): JQuery;
    isReadonly(): boolean;
    isEditable(): boolean;
    toggleReadonly(condition: boolean, shouldClearValueOnReadonly?: boolean): JQuery;
  }
}

(function ($) {
  $.fn.readonly = function (shouldClearValue: boolean = false) {
    $(this).each(function () {
      EditState.readonly(this, shouldClearValue);
    });
    return $(this);
  };
  $.fn.editable = function () {
    $(this).each(function () {
      EditState.editable(this)
    });

    return $(this);
  };
  $.fn.isReadonly = function () {
    return EditState.isReadonly($(this).first()[0]);
  }
  $.fn.isEditable = function () {
    return EditState.isEditable($(this).first()[0]);
  }
  $.fn.toggleReadonly = function (condition, shouldClearValueOnReadonly: boolean = false) {
    $(this).each(function () {
      EditState.toggleReadonly(this, condition, shouldClearValueOnReadonly);
    });
    return $(this);
  }
})($);

export class EditState {

  public static readonly(htmlElement: HTMLElement, shouldClearValue: boolean = false): void {
    let element = Element.from(htmlElement);
    element.userFacingElement.setAttribute('readonly', 'readonly');
    if (shouldClearValue)
      element.value(null);
  }

  public static editable(htmlElement: HTMLElement): void {
    let element = Element.from(htmlElement);
    element.userFacingElement.removeAttribute('readonly');
  }

  public static isReadonly(htmlElement: HTMLElement): boolean {
    let element = Element.from(htmlElement);
    return element.userFacingElement.hasAttribute('readonly');
  }

  public static isEditable(element: HTMLElement): boolean {
    return !this.isReadonly(element);
  }

  public static toggleReadonly(htmlElement: HTMLElement, condition: boolean, shouldClearValueOnReadonly: boolean = false): void {
    if (condition)
      this.readonly(htmlElement, shouldClearValueOnReadonly);
    else
      return this.editable(htmlElement);
  }
}


export default EditState;


$(document).on('click.rustig.readonly', '.input-radio-group[readonly] input', function (e) {
  return false;
});
